import React from 'react';
import { Route, Switch } from 'react-router-dom';

import EmailAuthAction from './screens/EmailAuthAction';
import ForgotPassword from './screens/ForgotPassword';
import SignIn from './screens/SignIn';
import SignUp from './screens/SignUp';
import EmailLink from './screens/EmailLink';
import ResetPassword from './screens/ResetPassword';

const Auth = () => (
  <Switch>
    <Route exact path="/auth_email_action" component={EmailAuthAction} />
    <Route exact path="/signin" component={SignIn} />
    <Route exact path="/signup" component={SignUp} />
    <Route exact path="/forgot_password" component={ForgotPassword} />
    <Route exact path="/email_link" component={EmailLink} />
    <Route exact path="/reset_password" component={ResetPassword} />
  </Switch>
);

export default React.memo(Auth);
